export default "__VITE_ASSET__Bwp9PcH2__"